import React, { createContext, FC, ReactNode, useEffect, useState } from 'react'
import { useMediaQuery } from 'react-responsive'

const isLargeScreen: boolean = true
const isTabletteScreen: boolean = false
const isLargeHeightScreen: boolean = false
const isMenuLargeScreen: boolean = true

export const ResponsiveContext = createContext({
	isLargeScreen,
	isTabletteScreen,
	isLargeHeightScreen,
	isMenuLargeScreen
})

interface ResponsiveProviderProps {
	children: ReactNode
}

export const ResponsiveProvider: FC<ResponsiveProviderProps> = ({ children }) => {
	// On triche pour le SSR en utilisant un max-width
	const isLargeScreen = !useMediaQuery(
		{
			query: '(max-width: 959px)'
		}
	)

	const isTabletteScreen = useMediaQuery(
		{
			query: '(min-width: 600px)'
		}
	)

	const isLargeHeightScreen = useMediaQuery(
		{
			query: '(min-height:800px)'
		}
	)

	// On définit un breakpoint spécifique pour lequel on passe en mobile
	const isMenuLargeScreen = !useMediaQuery(
		{
			query: '(max-width: 1313px)'
		}
	)

	/**
	 * À cause du SSR, quand on arrive sur le mobile, on a du html de desktop. Pour une raison inconnue, le html du
	 * desktop est conservé en même temps que celui du mobile. Pour contourner ce problème, on force un rerender
	 * complet de l'application avec un hack.
	 */
	const [usedToForceRerender, setUsedToForceRerender] = useState<boolean>(true)

	useEffect(() => {
		const videoHero = document.querySelector('video')
		// Si on passe en mobile et qu'il n'y a pas de vidéo en cours de lecture
		if (!isLargeScreen && (!videoHero || !videoHero.controls)) {
			setUsedToForceRerender(false)
			setTimeout(() => {
				setUsedToForceRerender(true)
			}, 0)
		}
	}, [isLargeScreen, isTabletteScreen, isLargeHeightScreen])

	if (!usedToForceRerender) {
		return null
	}

	return (
		<ResponsiveContext.Provider
			value={{
				isLargeScreen,
				isTabletteScreen,
				isLargeHeightScreen,
				isMenuLargeScreen
			}}
		>
			{children}
		</ResponsiveContext.Provider>
	)
}